












































import ZenButton from '@reciprocity/button';

export default {
  name: 'GenericCard',
  components: {
    ZenButton,
  },
  props: {
    okDisabled: {
      type: Boolean,
      default: false,
    },
    okLoader: {
      type: Boolean,
      default: false,
    },
    okOnly: {
      type: Boolean,
      default: false,
    },
    okTitle: {
      type: String,
      default: 'OK',
    },
    okVariant: {
      type: String,
      default: 'primary',
    },
    cancelDisabled: {
      type: Boolean,
      default: false,
    },
    cancelTitle: {
      type: String,
      default: 'Cancel',
    },
    cancelVariant: {
      type: String,
      default: 'link',
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
  methods: {
    ok() {
      this.$emit('ok');
    },
    cancel() {
      this.$emit('cancel');
    },
  },
};
